import { render, staticRenderFns } from "./CustomVueEditorComponent.vue?vue&type=template&id=33037ae0&class=custom-vue&"
import script from "./CustomVueEditorComponent.vue?vue&type=script&lang=ts&"
export * from "./CustomVueEditorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CustomVueEditorComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports